jQuery(document).ready(function ($) {

	/**
	 * Smooth scroll to anchor
	 */
	$('a[href*="#"]:not([href="#"]):not([href^="#tab-"]):not(".ez-toc-link")').on('click', function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top - ($('.site-header').outerHeight() + 50)
				}, 700);

				// remove anchor from url
				var hash = location.hash.replace('#', '');
				if (hash != '') {
					location.hash = '';
				}

				return false;
			}
		}

	});

	$('a[href="#tab-title-reviews"].woocommerce-product-rating').on('click', function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				if (!target.hasClass('active')) {
					target.find('a[href="#tab-reviews"]').trigger('click')
				}

				$('html,body').animate({
					scrollTop: target.offset().top - ($('.site-header').outerHeight() + 50)
				}, 300);

				// remove anchor from url
				var hash = location.hash.replace('#', '');
				if (hash != '') {
					location.hash = '';
				}

				return false;
			}
		}

	});

});
